// LT-314 — thin wrapper around the shared MembersTab so the hub's
// /settings/team sub-route can mark the onboarding checklist
// "Invite a teammate" task complete on mount. MembersTab itself stays
// workspace-agnostic and unchanged.
import React, { useEffect } from 'react';
import MembersTab from '../SettingsPage/MembersTab/MembersTab';
import { markTeamViewed } from '../../components/OnboardingChecklist/useChecklistSignals';

const SettingsTeamTab: React.FC = () => {
  useEffect(() => {
    markTeamViewed();
  }, []);

  return <MembersTab />;
};

export default SettingsTeamTab;
